import { useEffect } from "react";
import { useAppDispatch } from "@/hooks";
import { useSelector } from "react-redux";
import {
  startSignalRConnection,
  selectIsSignalRConnected,
  selectIsSignalRConnecting,
} from "@/features";
import { log } from "@/helpers";

const IS_TESTING_MODE = import.meta.env.VITE_PLAYWRIGHT_TESTING_MODE === "true";

interface SignalRProviderProps {
  children: React.ReactNode;
}

export function SignalRProvider({ children }: Readonly<SignalRProviderProps>) {
  const dispatch = useAppDispatch();
  const isConnected = useSelector(selectIsSignalRConnected);
  const isConnecting = useSelector(selectIsSignalRConnecting);

  useEffect(() => {
    if (!isConnected && !isConnecting && !IS_TESTING_MODE) {
      const connectionPromise = dispatch(
        startSignalRConnection("notifications"),
      );

      connectionPromise.then((result) => {
        if (result.type === startSignalRConnection.rejected.type) {
          log("SignalRProvider", "SignalR connection failed:", result);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{children}</>;
}
